import {
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { UtilsService } from 'src/app/services';
import { images } from 'src/images';
import { NgClass } from '@angular/common';

@Component({
  selector: 'app-pagination',
  templateUrl: './pagination.component.html',
  styleUrl: './pagination.component.scss',
  imports: [NgClass],
})
export class PaginationComponent {
  @Input() id?: any;
  @Input() pagination: any;
  @Input() right?: boolean = true;
  @Input() inline?: boolean = false;
  @Input() small?: boolean = false;
  @Input() maxLength?: number = 7;
  @Input() disabled?: boolean = false;
  @Input() loading?: boolean = false;
  @Input() baseUrl?: string;
  @Output() changePage = new EventEmitter<{
    isNext: boolean;
    specificPage?: number;
  }>();

  public images = images;
  public isNaN = Number.isNaN;

  constructor(public utilsService: UtilsService) {}

  getPageUrl(page: number): string {
    if (!this.baseUrl) return '';
    if (page <= 1) return this.baseUrl;
    // Handle URLs that already have query params
    const separator = this.baseUrl.includes('?') ? '&' : '?';
    return `${this.baseUrl}${separator}page=${page}`;
  }

  onPageClick(event: MouseEvent, page: number): void {
    // Allow middle-click and Ctrl/Cmd+click to open in new tab
    if (event.ctrlKey || event.metaKey || event.button === 1) {
      return;
    }
    event.preventDefault();
    if (!this.disabled) {
      this.changePage.emit({ isNext: false, specificPage: page });
    }
  }

  onArrowClick(event: MouseEvent, isNext: boolean): void {
    // Allow middle-click and Ctrl/Cmd+click to open in new tab
    if (event.ctrlKey || event.metaKey || event.button === 1) {
      return;
    }
    event.preventDefault();
    const canNavigate = isNext ? !this.pagination.last : !this.pagination.first;
    if (!this.disabled && canNavigate) {
      this.changePage.emit({ isNext });
    }
  }
}
